import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Logo } from '../components/LogoOptions';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';

const PaymentCancel = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const submissionId = searchParams.get('submission_id');

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      {/* Header */}
      <header className="bg-white border-b border-gray-200 shadow-sm">
        <div className="container mx-auto px-4 py-4">
          <Logo />
        </div>
      </header>

      {/* Cancel Content */}
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-2xl mx-auto">
          <Card className="p-12 text-center">
            <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <XCircle className="w-12 h-12 text-gray-600" />
            </div>
            
            <h1 className="text-3xl font-bold text-gray-900 mb-4">
              Payment Cancelled
            </h1>
            
            <p className="text-lg text-gray-600 mb-8">
              Your payment was not completed. No charges have been made to your account.
            </p>

            <div className="bg-amber-50 border-l-4 border-amber-500 p-6 mb-8 text-left">
              <h3 className="font-bold text-lg mb-2 text-amber-900">What's Next?</h3>
              <p className="text-amber-800">
                Your transaction details have been saved. You can return to complete payment at any time, 
                or we'll send you an invoice to pay at closing.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button 
                onClick={() => navigate('/')}
                className="bg-gray-900 hover:bg-gray-800 text-white px-8 py-6 text-lg"
              >
                Return to Home
              </Button>
            </div>

            <p className="text-sm text-gray-500 mt-8">
              Questions? Call us at 206-627-0768 or email info@ezflowtc.com
            </p>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
